import { createAsyncThunk } from '@reduxjs/toolkit'
import { firestoreService } from '../../services/firebase/firestore.service'
import { User, Student, UserRole } from '@/types/user.types'


const getCollectionName = (role: string)  => {
  console.log('role', role)
  switch (role) {
    case 'admin':
    case 'dir':
    case 'superadmin':
    case 'educator':
      return 'users'
    case 'student':
      return 'students'
    case 'attendant':
      return 'attendants'
    default:
      return 'users'
  }
}

export const getUserByDocId = createAsyncThunk<User, {docId:string, role:UserRole}>(
  'users/getUserByDocId',
  async ({docId, role}, { rejectWithValue }) => {
    try {

      const collectionName = getCollectionName(role)

      const user = await firestoreService.getDocument(collectionName, docId)

      console.log('user', user)
      if (!user) {

        return rejectWithValue('User not found')
      }

      return user as User
    } catch (error: any) {
      return rejectWithValue(error.message || 'Failed to fetch user')
    }
  }
)


export const updateUser = createAsyncThunk<User, { id: string; data:  Omit<User, 'id' >,  role:UserRole }>(
  'users/updateUser',
  async ({ id, data, role }, { rejectWithValue }) => {
    try {

      const collectionName = getCollectionName(role)

      await firestoreService.updateDocument(collectionName, id, data)

      const updatedUser = await firestoreService.getDocument(collectionName, id)

      if (!updatedUser) {
        return rejectWithValue('Failed to fetch updated user')
      }

      return updatedUser as User
    } catch (error: any) {
      return rejectWithValue(error.message || 'Failed to update user')
    }
  }
)

export const getStudentByIdentifier = createAsyncThunk<User, string>(
  'users/getStudentByIdentifier',
  async (identifier, { rejectWithValue }) => {
    try {
      const users = await firestoreService.getDocuments('students', [
        firestoreService.where('identifier', '==', identifier),
        firestoreService.where('suspended', '==', false)
      ])

      if (!users || users.length === 0) {
        return rejectWithValue(`Estudiante del documento ${identifier} no encontrado`)
      }

      const studentUser = users[0]

      return studentUser as User
    } catch (error: any) {
      return rejectWithValue(error.message || 'Failed to fetch student')
    }
  }
)

export const validateStudentsList = createAsyncThunk<
  Student[],
  string[],
  { rejectValue: { documentId: string; message: string } }
>(
  'users/validateStudentsList',
  async (documentIds, { rejectWithValue }) => {
    try {
      const validatedStudents: Student[] = []

      for (const documentId of documentIds) {

        const users = await firestoreService.getDocuments('students', [
          firestoreService.where('identifier', '==', documentId),
          firestoreService.where('suspended', '==', false)
        ])

         
        if (!users || users.length === 0) {
          return rejectWithValue({
            documentId,
            message: `El estudiante con documento ${documentId} no existe`
          })
        }

        const studentUser = users[0]

        // Convert User to Student type
        const student: Student = {
          id: studentUser.identifier || '',
          name: studentUser.displayName || '',
          documentId: studentUser.documentId || ''
        }

        validatedStudents.push(student)
      }

      return validatedStudents
    } catch (error: any) {
      return rejectWithValue({
        documentId: '',
        message: error.message || 'Failed to validate students'
      })
    }
  }
)

